import { render, staticRenderFns } from "./SpaceInvitations.vue?vue&type=template&id=1ab6ec26&"
import script from "./SpaceInvitations.vue?vue&type=script&lang=js&"
export * from "./SpaceInvitations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports